import { createAction } from '@reduxjs/toolkit';
export const ON_INVITE = 'ON_INVITE';
export const onInviteAction = createAction(ON_INVITE);